export const mapButtonVariantToTextStyle = {
    primary: { type: 'all-caps', style: 'bold', size: 'base', color: 'white' },
    'primary-black': { type: 'all-caps', style: 'bold', size: 'base', color: 'white' },
    secondary: { type: 'all-caps', style: 'bold', size: 'base', color: 'slt-pepper.1000' },
    tertiary: { type: 'body', style: 'bold', size: 'base', color: 'slt-pepper.1000' },
    'text-button': { type: 'link', style: 'regular', size: 'small', color: 'slt-pepper.1000' },
    'text-button-no-hover': {
        type: 'link',
        style: 'regular',
        size: 'small',
        color: 'slt-pepper.1000',
    },
    'text-button-no-underline': {
        type: 'body',
        style: 'regular',
        size: 'small',
        color: 'slt-pepper.1000',
    },
    'quantity-button': { type: 'all-caps', style: 'bold', size: 'base', color: 'slt-pepper.1000' },
    chip: { type: 'body', style: 'regular', size: 'base', color: 'slt-pepper.1000' },
    'menu-chip': { type: 'body', style: 'regular', size: 'base', color: 'slt-pepper.1000' },
};
